import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import * as moment from 'moment-timezone';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-activation-date',
    templateUrl: './activation-date.component.html',
    styleUrls: ['./activation-date.component.scss']
})
export class ActivationDateComponent implements OnInit, AfterViewInit, OnDestroy {

    private readonly destroyed = new Subject();
    @Input() minDate: moment.Moment;
    @Input() timeZone: string;
    @Input() setDefaultDate: boolean;
    @Output() activationDate: EventEmitter<any> = new EventEmitter<any>();
    dateControl: FormControl;
    dateAsCerControl: FormControl;
    dateAsCer = false;

    constructor() {
        this.dateControl = new FormControl(null, [Validators.required]); // use "now" as a start
        this.dateAsCerControl = new FormControl(false, [Validators.required]);
    }

    ngOnInit(): void {
        this.dateControl.valueChanges
            .pipe(takeUntil(this.destroyed))
            .subscribe(date => this.activationDate.emit(this.dateControl.invalid ? null : date));

        this.dateAsCerControl.valueChanges
            .pipe(takeUntil(this.destroyed))
            .subscribe(value => {
                this.dateAsCer = value;
                if (value) {
                    if (this.minDate) {
                        this.dateControl.setValue(this.minDate);
                    }
                    this.dateControl.disable();
                } else {
                    this.dateControl.enable();
                }
            });
    }

    ngAfterViewInit(): void {
        // Set datepicker value to today if min date exists, or we need a default date
        if (this.minDate || this.setDefaultDate) {
            const today = moment.tz(this.timeZone).startOf('day');
            this.dateControl.setValue(today);
        }
    }

    ngOnDestroy(): void {
        this.destroyed.next();
        this.destroyed.complete();
    }


}
